import { ReactNode, useMemo } from 'react';

import { useLocale } from '@adsk/alloy-react-locale';

import { statuses } from '../consts';
import { ItemState } from '../types';

interface Status {
  name: string;
  color: string;
  statusText: ReactNode;
  stateText?: ReactNode;
}

export default function useStatus(stateId: ItemState): Status {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  const status = statuses[stateId];
  const { statusText, stateText } = status;

  return useMemo(
    () => ({
      ...status,
      statusText: T.translate(statusText),
      stateText: stateText && T.translate(stateText),
    }),
    [T, stateText, statusText, status],
  );
}
